import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from 'ngx-auth';

import { TokenStorageService } from './token-storage.service';
import { environment } from "environments/environment";

interface AccessData {
    accessToken: string;
    refreshToken: string;
}

@Injectable()
export class AuthenticationService implements AuthService {

    constructor(private http: HttpClient, private router: Router, private tokenStorage: TokenStorageService) { }

    /**
     * Check, if user already authorized.
     * @description Should return Observable with true or false values
     * @returns {Observable<boolean>}
     * @memberOf AuthService
     */
    public isAuthorized(): Observable<boolean> {
        return this.tokenStorage
            .getAccessToken()
            .map(token => !!token);
    }

    /**
     * Get access token
     * @description Should return access token in Observable from e.g.
     * localStorage
     * @returns {Observable<string>}
     */
    public getAccessToken(): Observable<string> {
        return this.tokenStorage.getAccessToken();
    }

    /**
     * Function, that should perform refresh token verifyTokenRequest
     * @description Should be successfully completed so interceptor
     * can execute pending requests or retry original one
     * @returns {Observable<any>}
     */
    public refreshToken(): Observable<AccessData> {
        return this.tokenStorage
            .getRefreshToken()
            .switchMap((refreshToken: string) => {
                var headers = new HttpHeaders({ 'Content-Type': "application/x-www-form-urlencoded" });
                var data = "grant_type=refresh_token&client_id=" + environment.clientId + "&refresh_token=" + refreshToken;
                return this.http.post("/token", data, { headers: headers });
            })
            .do((res: any) => {
                try {
                    var result = (res || {});
                    var data = JSON.parse(result.Data);
                    if (data != {} && result.Code == "999") {
                        this.saveAccessData(data.access_token, data.refresh_token)
                    }
                    else {
                        throw {
                            name: "Auth Error",
                            message: result.Message,
                            htmlMessage: result.Message,
                            toString: function () { return this.name + ": " + this.message; }
                        };
                    }

                } catch (ex) {
                    throw ex;
                }
            })
            .catch((err) => {
                this.logout();
                return Observable.throw(err);
            });
    }

    /**
     * Function, checks response of failed request to determine,
     * whether token be refreshed or not.
     * @description Essentialy checks status
     * @param {Response} response
     * @returns {boolean}
     */
    public refreshShouldHappen(response: HttpErrorResponse): boolean {
        return response.status === 401
    }

    /**
     * Verify that outgoing request is refresh-token,
     * so interceptor won't intercept this request
     * @param {string} url
     * @returns {boolean}
     */
    public verifyTokenRequest(url: string): boolean {
        return url.endsWith('/token');
    }

    /**
     * Logout
     */
    public logout(): void {
        this.tokenStorage.clear();
        this.router.navigateByUrl('/login');
    }

    /**
     * Save access data in the storage
     *
     * @private
     * @param {AccessData} data
     */
    private saveAccessData(accessToken: string, refreshToken: string) {
        this.tokenStorage
            .setAccessToken(accessToken)
            .setRefreshToken(refreshToken);
    }

}



// WEBPACK FOOTER //
// ./src/app/brightserve/authentication.service.ts